// Components and call state use this provider contract only. To change RTC vendors,
// add an adapter with the same methods and select it here.
export { agoraOpenIMProvider as rtcProvider } from './agoraOpenIMProvider';
